// frontend/src/App.js

import React from "react";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MappingForm from "./components/MappingForm";
import About from "./components/About";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

function PaperModal({ open, onClose }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>RIMap-RISC Publication</DialogTitle>
            <DialogContent>
	    	<p>
		    Chasles, S., Gaillard-Duchassin, Z., Quenneville, J., Lemaire, M., Gagnon, E., Major, F. 
		    RIMap-RISC: a transcriptome-wide database of structurally modeled human microRNA interactions.{" "}
		    <i>Genome Biology</i> <b>27</b>, 112 (2026).
		</p>				
                <p>
                    <a 
                        href="https://link.springer.com/article/10.1186/s13059-026-04008-y" 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        View the paper (Springer)
                    </a>
                </p>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

function AppContent() {
    return (
        <>
            <Header />
            <Container maxWidth={false} sx={{flex: 1, py: 4}}>
                <Routes>
                    <Route path="/" element={<MappingForm/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route
                        path="/paper"
                        element={
                            <>
                                <PaperModal open={true} onClose={() => window.history.back()}/>
                            </>
                        }
                    />
                    <Route path="*" element={<Navigate to="/"/>}/>
                </Routes>
            </Container>
            <Footer />
        </>
    );
}

function App() {
    return (
        <Router>
            <Box minHeight="100vh" display="flex" flexDirection="column">
                <AppContent />
            </Box>
        </Router>
    );
}

export default App;
